<template>
  <footer v-if="contactUs()" class="footer-clean maindiv" aria-hidden="true"></footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FooterBar',
  computed: {
    ...mapState('auth', ['user'])
  },
  data() {
    return {
      year: ''
    };
  },
  methods: {
    show() {
      if (this.$route.path === '/contactUs') {
        return false;
      }
      if (this.user) {
        return true;
      } 
        return false;
      
    },
    goToContactUs() {
      window.open('/contactUs', '_blank');
    },
    contactUs() {
      if (this.$route.path === '/contactUs') {
        return false;
      } 
        return true;
      
    }
  },
  mounted() {
    this.year = new Date().getFullYear();
  }
};
</script>

<style scoped>
.maindiv {
  display: flex;
  justify-content: space-between;
}

.footer-clean {
  margin: 0;
  padding: 0;
  border: 0;
  height: 0;
}

.contactButton {
  margin-top: 7px;
}

.contactButton:hover {
  opacity: 0.8;
}
</style>
